module.exports = __webpack_public_path__ + "media/images/landing/macbook-8e002aa28fd3c8b554d465ac06e75010.png";